import Vue from 'vue';
import Vuex from 'vuex';

import modules from './modules';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules,
  strict: process.env.NODE_ENV !== 'production',
  actions: {
    resetAllState() {
      return callAll(store, 'resetState');
    },
  },
});

// Automatically run the `init` action for every module, if one exists.
/* eslint-disable-next-line */

/**
 * Calls `actionName` for all registred modules, that actually have an action
 * with that name.
 *
 * @private
 * @param {Object} _store - The store to handle.
 * @param {String} actionName - The name of the action.
 */
function callAll(_store, actionName) {
  Object.keys(modules).forEach((moduleName) => {
    if (modules[moduleName].actions && modules[moduleName].actions[actionName]) {
      _store.dispatch(`${moduleName}/${actionName}`);
    }
  });
}

callAll(store, 'init');


export default store;
